class Enlace {

    descripcion: string;

    direccion: string;

    constructor(descripcion: string, direccion: string) {
        this.descripcion = descripcion;
        this.direccion = direccion;
    }

}

export default Enlace;